import React from 'react';
import '../template-file-css/document-file-template.css';


export const KMS_PsychEval = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='KMS_PsychEval' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Psychiatric Evaluation</h3></center>
                </p>

                <table>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'>Patient Name:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>DOB:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Age:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'> <input type='text' id='txtPatientName' name='txtPatientName' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtAge' name='txtAge' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Chief Complaint:</span>
                    <textarea id='txtChiefComplaint' name='txtChiefComplaint' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>History of Presenting Illness (HPI):</span>
                    <textarea id='txtPresentingIllness' name='txtPresentingIllness' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>Psych Hx:</b></p>

                <p className='w-750'> <span className='eleHeader'>Prior psych diagnoses:</span>
                    <input type='text' id='txtPriorPsychDiagnoses' name='txtPriorPsychDiagnoses' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Prior psych meds tried:</span>
                    <input type='text' id='txtMedsTried' name='txtMedsTried' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Reactions to prior psych meds:</span>
                    <input type='text' id='txtPsychMeds' name='txtPsychMeds' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>{`Prior inpatient psychiatric hospitalizations and dates (year):`}</span>
                    <input type='text' id='txtHospitalizations' name='txtHospitalizations' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Prior or current outpatient psych treatment:</span>
                    <input type='text' id='txtPsychTreatment' name='txtPsychTreatment' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Hx of self-harm and/or self-injurious behavior:</span>
                    <input type='text' id='txtSelfInjuriousBehavior' name='txtSelfInjuriousBehavior' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Any access to firearms:</span>
                    <input type='text' id='txtFirearms' name='txtFirearms' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Current SI:</span>
                    <input type='text' id='txtCurrentSi' name='txtCurrentSi' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Plan:</span>
                    <input type='text' id='txtPlan' name='txtPlan' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Recent attempts:</span>
                    <input type='text' id='txtRecentAttempts' name='txtRecentAttempts' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Prior attempts:</span>
                    <input type='text' id='txtPriorAttempts' name='txtPriorAttempts' className='add-only' />
                </p>

                <p className='w-750'><b>Family psych hx:</b></p>

                <p className='w-750'> <span className='eleHeader'>Family members with psych illnesses:</span>
                    <input type='text' id='txtPsychIllnesses' name='txtPsychIllnesses' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Psychiatric meds that worked (if known):</span>
                    <input type='text' id='txtPsychiatricMeds' name='txtPsychiatricMeds' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Suicide Attempts:</span>
                    <input type='text' id='txtSuicideAttempts' name='txtSuicideAttempts' className='add-only' />
                </p>

                <p className='w-750'><b>Substance Use Hx:</b></p>

                <p className='w-750'> <span className='eleHeader'>Drug of choice:</span>
                    <input type='text' id='txtDrugOfChoice' name='txtDrugOfChoice' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Duration of Use:</span>
                    <input type='text' id='txtDurationOfUse' name='txtDurationOfUse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Route of use/preferred method of use:</span>
                    <input type='text' id='txtRouteOfUse' name='txtRouteOfUse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Quantity used:</span>
                    <input type='text' id='txtQuantityUsed' name='txtQuantityUsed' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Last use:</span>
                    <input type='text' id='txtLastUse' name='txtLastUse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Other illicit use:</span>
                    <input type='text' id='txtOtherIllicitUse' name='txtOtherIllicitUse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Detox admission and treatment:</span>
                    <input type='text' id='txtDetoxAdmission' name='txtDetoxAdmission' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Rehab admission and treatment:</span>
                    <input type='text' id='txtRehabAdmission' name='txtRehabAdmission' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Hx of Seizures when withdrawing or detoxing:</span>
                    <input type='text' id='txtHxOfSeizures' name='txtHxOfSeizures' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Urine drug screen result:</span>
                    <input type='text' id='txtUrineDrugScreen' name='txtUrineDrugScreen' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Longest period of sobriety:</span>
                    <input type='text' id='txtLongestPeriod' name='txtLongestPeriod' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Known triggers for relapse:</span>
                    <input type='text' id='txtKnownTriggersRelapse' name='txtKnownTriggersRelapse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>PMP query results:</span>
                    <input type='text' id='txtPmpQueryResults' name='txtPmpQueryResults' className='add-only' />
                </p>

                <p className='w-750'><b>Medical Hx:</b></p>

                <p className='w-750'> <span className='eleHeader'>Medical Diagnoses:</span>
                    <input type='text' id='txtMedicalDiagnoses' name='txtMedicalDiagnoses' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Medications:</span>
                    <input type='text' id='txtMedications' name='txtMedications' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Surgical Hx:</span>
                    <input type='text' id='txtSurgicalHx' name='txtSurgicalHx' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Allergies:</span>
                    <input type='text' id='txtAllergies' name='txtAllergies' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Last menstrual period</span>
                    <input type='text' id='txtLastMenstrualPeriod' name='txtLastMenstrualPeriod' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>PCP:</span>
                    <input type='text' id='txtPcp' name='txtPcp' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Medical Specialties scheduled:</span>
                    <input type='text' id='txtMedicalSpecialties' name='txtMedicalSpecialties' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>How many children do you have:</span>
                    <input type='text' id='txtHowManyChildren' name='txtHowManyChildren' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Did you experience any complications during pregnancy: If so, what were the complications?</span>
                    <input type='text' id='txtcomplicationsPregnancy' name='txtcomplicationsPregnancy' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Did you have any complications during the birth of children: If so, what were the complications?</span>
                    <input type='text' id='txtBirthOfChildren' name='txtBirthOfChildren' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Any drug use during pregnancy?</span>
                    <input type='text' id='txtAnyDrugUse' name='txtAnyDrugUse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Did you take prescription meds during pregnancy?</span>
                    <input type='text' id='txtPrescriptionMeds' name='txtPrescriptionMeds' className='add-only' />
                </p>

                <p className='w-750'><b>For Kids and Adolescents:</b></p>

                <p className='w-750'> <span className='eleHeader'>Pediatrician Name:</span>
                    <input type='text' id='txtPediatricianName' name='txtPediatricianName' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Up to date with immunizations:</span>
                    <input type='text' id='txtImmunizations' name='txtImmunizations' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Full Term Delivery:</span>
                    <input type='radio' id='rbFullTermDelivery_Yes' name='rbFullTermDelivery' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFullTermDelivery_No' name='rbFullTermDelivery' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'>Pre term delivery?</span>
                    <input type='radio' id='rbPreTermDelivery_Yes' name='rbPreTermDelivery' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPreTermDelivery_No' name='rbPreTermDelivery' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'>If yes, How much time was spent in NICU:</span>
                    <input type='text' id='txtNicu' name='txtNicu' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Birth Weight:</span>
                    <input type='text' id='txtBirthWeight' name='txtBirthWeight' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Were all developmental milestones met at appropriate age (walking, talking):</span>
                    <input type='text' id='txtDevelopmentalMilestones' name='txtDevelopmentalMilestones' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Current grade level:</span>
                    <input type='text' id='txtCurrentGradeLevel' name='txtCurrentGradeLevel' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Has child ever been skipped or had to repeat a grade:</span>
                    <input type='text' id='txtRepeatGrade' name='txtRepeatGrade' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Special education classes:</span>
                    <input type='text' id='txtSpecialEducationClasses' name='txtSpecialEducationClasses' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Any suspensions or expulsions:</span>
                    <input type='text' id='txtExpulsions' name='txtExpulsions' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Pubescent onset:</span>
                    <input type='text' id='txtPubescentOnset' name='txtPubescentOnset' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Age of menses onset:</span>
                    <input type='text' id='txtAgeOfMenses' name='txtAgeOfMenses' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>LMP:</span>
                    <input type='text' id='txtLmp' name='txtLmp' className='add-only' />
                </p>

                <p className='w-750'><b>Social Hx:</b></p>

                <p className='w-750'> <span className='eleHeader'>Current living situation:</span>
                    <input type='text' id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Marital Status:</span>
                    <input type='text' id='txtMaritalStatus' name='txtMaritalStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>How many children do you have (living and deceased):</span>
                    <input type='text' id='txtLivingAndDeceased' name='txtLivingAndDeceased' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Employment Status:</span>
                    <input type='text' id='txtEmploymentStatus' name='txtEmploymentStatus' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Highest level of education:</span>
                    <input type='text' id='txtHighestLevelOfEducation' name='txtHighestLevelOfEducation' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>MilitaryHx:</span>
                    <input type='text' id='txtMilitaryHx' name='txtMilitaryHx' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Hx of physical or sexual abuse?</span>
                    <input type='text' id='txtSexualAbuse' name='txtSexualAbuse' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Witness to or victim of traumatic events:</span>
                    <input type='text' id='txtTraumaticEvents' name='txtTraumaticEvents' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Primary supports:</span>
                    <input type='text' id='txtPrimarySupports' name='txtPrimarySupports' className='add-only' />
                </p>

                <p className='w-750'><b>Legal History:</b></p>

                <p className='w-750'> <span className='eleHeader'>Prior arrests:</span>
                    <input type='text' id='txtPriorArrests' name='txtPriorArrests' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Prior convictions:</span>
                    <input type='text' id='txtPriorConvictions' name='txtPriorConvictions' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Prior incarcerations:</span>
                    <input type='text' id='txtPriorIncarcerations' name='txtPriorIncarcerations' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Current or pending charges:</span>
                    <input type='text' id='txtCurrentCharges' name='txtCurrentCharges' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Upcoming court dates:</span>
                    <input type='text' id='txtUpcomingCourtDates' name='txtUpcomingCourtDates' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Probation, parole:</span>
                    <input type='text' id='txtProbationParole' name='txtProbationParole' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>DEPRESSION:</span>
                    <span className='small'>{`Denies h/o 2 week periods (most of the day, nearly everyday) episodes of dysphoria/emptiness/hopelessness or having less interest/enjoyment in things.`}</span>
                    <textarea id='txtDepression' name='txtDepression' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>MANIC/HYPOMANIC EPISODES:</span>
                    <span className='small'>{`Denies h/o distinct 3+ day period of abnormally and persistently elevated/expansive/irritable mood, inflated self-esteem, or decreased need for sleep.`}</span>
                    <textarea id='txtHypomanicEpisodes' name='txtHypomanicEpisodes' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>GENERALIZED ANXIETY DISORDER:</span>
                    <span className='small'>{`Denies h/o excessive anxiety/worry about several routine things, present for most of the day.`}</span>
                    <textarea id='txtAnxietyDisorder' name='txtAnxietyDisorder' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>PANIC DISORDER:</span>
                    <span className='small'>{`Admits or Denies h/o sudden unexpected/unprovoked episodes of intensive anxiety/fright/uncomfortableness.`}</span>
                    <textarea id='txtPanicDisorder' name='txtPanicDisorder' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>AGORAPHOBIA:</span>
                    <span className='small'>{`Admits or Denies h/o feeling anxious/uneasy in places/situations where help may not be available or escape might be difficult.`}</span>
                    <textarea id='txtAgoraphobia' name='txtAgoraphobia' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>SOCIAL ANXIETY DISORDER:</span>
                    <span className='small'>{`Admits or Denies h/o persistent fear/anxiety of being the focus of attention or being humiliated/embarrassed/rejected to the point of causing avoidance, suffering through them, or needing a companion to face them.`}</span>
                    <textarea id='txtSocialAnxiety' name='txtSocialAnxiety' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>OCD:</span>
                    <span className='small'>{`Admits or Denies h/o recurrent thoughts/impulses/images that were unwanted/distasteful/inappropriate/intrusive/distressing.`}</span>
                    <textarea id='txtOcd' name='txtOcd' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>PTSD:</span>
                    <span className='small'>{`Admits or Denies h/o experienced or witnessed extremely traumatic event of actual or threatened death, serious injury, or sexual violence.
                    Denies h/o repeatedly re-experiencing the event in unwanted mentally distressing ways (ex: recurrent dreams, intent recollections or memories, or flashbacks).`}</span>
                    <textarea id='txtPtsd' name='txtPtsd' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>PSYCHOSIS:</span>
                    <span className='small'>{`Admits or Denies h/o paranoia, TB, TI, mind reading, IoR. Denies h/o AVH.`}</span>
                    <textarea id='txtPsychosis' name='txtPsychosis' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>EATING DISORDERS:</span>
                    <span className='small'>{`Admits or Denies h/o binge eating or compensatory purging, restrictive eating, laxatives, enemas, diuretics.`}</span>
                    <textarea id='txtEatingDisorders' name='txtEatingDisorders' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>ADHD:</span>
                    <span className='small'>{`Admits or Denies h/o inattentiveness, hyperactivity, impulsivity, disorganization, poor time management, distractibility, inability to complete tasks, impatience, constant interrupting conversations, careless mistakes, unable to sit still`}</span>
                    <textarea id='txtAdhd' name='txtAdhd' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>ODD:</span>
                    <span className='small'>{`Admits or Denies h/o refusing to follow rules, excessive arguments with adults, blaming others for misbehavior and mistakes, behavior intended to upset or annoy others,`}</span>
                    <textarea id='txtOdd' name='txtOdd' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>CONDUCT DISORDER:</span>
                    <span className='small'>{`Admits or Denies h/o violating the rights of others, physical aggression, lying or manipulation, and delinquent behaviors`}</span>
                    <textarea id='txtConductDisorder' name='txtConductDisorder' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Integumentary: denies rash</span>
                    <textarea id='txtIntegumentary' name='txtIntegumentary' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Gastrointestinal:</span>
                    <span className='small'>{`denies nausea, denies vomiting, denies constipation, denies diarrhea Neurological: denies headache Psychiatric: denies SI, denies HI, denies AVH`}</span>
                    <textarea id='txtGastrointestinal' name='txtGastrointestinal' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>CONSTITUTIONAL:</b></p>

                <p className='w-750'>
                    <span className='eleHeader'>Vitals:</span>
                    <textarea id='txtVitals' name='txtVitals' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>General Appearance:</span>
                    <span className='small'>{`NAD, casually dressed, good h&g`}</span>
                    <textarea id='txtGeneralAppearance' name='txtGeneralAppearance' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>MUSCULOSKELETAL:</b></p>

                <p className='w-750'>
                    <span className='eleHeader'>Gait & Station:</span>
                    <textarea id='txtGaitStation' name='txtGaitStation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Abnormal Involuntary Movements:</span>
                    <textarea id='txtInvoluntaryMovements' name='txtInvoluntaryMovements' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>PSYCHIATRIC MSE:</b></p>

                <p className='w-750'>
                    <span className='eleHeader'>Speech:</span>
                    <textarea id='txtSpeech' name='txtSpeech' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Mood:</span>
                    <textarea id='txtMood' name='txtMood' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Affect:</span>
                    <textarea id='txtAffect' name='txtAffect' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Thought Process:</span>
                    <textarea id='txtThoughtProcess' name='txtThoughtProcess' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Associations:</span>
                    <textarea id='txtAssociations' name='txtAssociations' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Thought Content:</span>
                    <textarea id='txtThoughtContent' name='txtThoughtContent' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Insight:</span>
                    <textarea id='txtInsight' name='txtInsight' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Judgement:</span>
                    <textarea id='txtJudgement' name='txtJudgement' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Orientation:</span>
                    <textarea id='txtOrientation' name='txtOrientation' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Recent & Remote Memory:</span>
                    <textarea id='txtRemoteMemory' name='txtRemoteMemory' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Attention Span & Concentration:</span>
                    <textarea id='txtConcentration' name='txtConcentration' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Language:</span>
                    <textarea id='txtLanguage' name='txtLanguage' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Fund of Knowledge:</span>
                    <textarea id='txtFundOfKnowledge' name='txtFundOfKnowledge' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Impression:</span>
                    <textarea id='txtImpression' name='txtImpression' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Plan:</span>
                    <textarea id='txtPlan' name='txtPlan' className='add-only'></textarea>
                </p>

                <p className='w-750'>{`Discussed diagnosis, treatment alternatives & risks vs benefits & potential side effects (including most common side effects, most severe side effects, inherent unpredictability of medications in general) of each option. Discussed contingency plans (continue the treatment vs stop the treatment vs changing how to take the treatment vs call the clinic vs call 911/go to ED) of different adverse reactions and different psychiatric symptomatology. Patient expresses understanding, agrees that the benefits outweigh the risks, and would like to pursue treatment at this time. Verbal informed consent obtained, which patient has capacity to do so.`}
                </p>


            </div>
        </form>

    )
} 